// Module
var code = `<div class="row form-row"> <div class="col-xs-12"> <div class="field"> <label class="input-label required">Description</label> <input type="text" placeholder="Enter a description" label="Description" ng-model="vm.form.data.method.data.description" name="description" ui-input required/> </div> </div> </div> `;
// Exports
module.exports = code;